import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import {
	MatExpansionPanel,
	MatExpansionPanelHeader,
	MatExpansionPanelTitle,
	MatExpansionPanelDescription,
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

/**
 * Example
 * <au-expansion-panel>
 *
 * 	<ng-container panel-title>
 * 		<div>
 * 		  Title of expanded element
 * 		</div>
 * 	</ng-container>
 *
 * 	<ng-container panel-description>
 * 	  <div>
 * 	   Content that contain in right side of title
 * 	  </div>
 * 	</ng-container>
 *
 * 	<ng-container panel-content>
 * 	  <div>
 * 	    Main content in expandable panel
 * 	  </div>
 * 	<ng-container />
 *
 * </au-expansion-panel>
 */
@Component({
	selector: 'au-expansion-panel',
	templateUrl: './au-expansion-panel.component.html',
	styleUrls: ['./au-expansion-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatExpansionPanel,
		MatExpansionPanelHeader,
		MatExpansionPanelTitle,
		MatIcon,
		NgClass,
		MatExpansionPanelDescription,
	],
})
export class AuExpansionPanelComponent {
	@Input() expanded = false;
	@Input() panelCanBeExpanded = true;

	afterCollapseHandler() {
		this.expanded = false;
	}

	afterExpandHandler() {
		this.expanded = true;
	}
}
